import navHome from "../assets/icons/ds/nav-home.svg?raw";
import navDocuments from "../assets/icons/ds/nav-documents.svg?raw";
import navRfq from "../assets/icons/ds/nav-rfq.svg?raw";
import navCustomers from "../assets/icons/ds/nav-customers.svg?raw";
import navAi from "../assets/icons/ds/nav-ai.svg?raw";
import navAgents from "../assets/icons/ds/nav-agents.svg?raw";
import navProduction from "../assets/icons/ds/nav-production.svg?raw";
import navStock from "../assets/icons/ds/nav-stock.svg?raw";
import navIntegrations from "../assets/icons/ds/nav-integrations.svg?raw";
import navSettings from "../assets/icons/ds/nav-settings.svg?raw";
import type { MessageKey } from "./i18n";
import type { Page } from "../routes";

export type NavItem = {
  id: string;
  /** Null items render in the sidebar but do not navigate. */
  page: Page | null;
  labelKey: MessageKey;
  hintKey?: MessageKey;
  icon: string;
  badgeKey?: MessageKey;
};

export type NavGroup = { labelKey: MessageKey; items: NavItem[] };

/** Groups mirror the design-system sidebar (Figma App / Sidebar). */
export const NAV_GROUPS: NavGroup[] = [
  {
    labelKey: "sidebar.workspace",
    items: [
      {
        id: "home",
        page: "home",
        labelKey: "palette.home",
        hintKey: "sidebar.hint.home",
        icon: navHome,
      },
      {
        id: "drawings",
        page: "drawings",
        labelKey: "sidebar.documents",
        hintKey: "sidebar.hint.drawings",
        icon: navDocuments,
      },
      {
        id: "rfq",
        page: "rfq",
        labelKey: "palette.rfq",
        hintKey: "sidebar.hint.rfq",
        icon: navRfq,
      },
      {
        id: "customers",
        page: "customers",
        labelKey: "palette.customers",
        hintKey: "sidebar.hint.customers",
        icon: navCustomers,
      },
    ],
  },
  {
    labelKey: "sidebar.group.ai",
    items: [
      {
        id: "ai",
        page: "ai",
        labelKey: "palette.aiShort",
        hintKey: "sidebar.hint.ai",
        icon: navAi,
      },
      {
        id: "agents",
        page: "agents",
        labelKey: "sidebar.agents",
        hintKey: "sidebar.hint.agents",
        icon: navAgents,
      },
    ],
  },
  {
    labelKey: "sidebar.group.data",
    items: [
      {
        id: "production",
        page: "production",
        labelKey: "sidebar.production",
        hintKey: "sidebar.hint.production",
        icon: navProduction,
      },
      {
        id: "erp",
        page: "erp",
        labelKey: "sidebar.stock",
        hintKey: "sidebar.hint.erp",
        icon: navStock,
      },
      {
        id: "integrations",
        page: "integrations",
        labelKey: "sidebar.integrations",
        hintKey: "sidebar.hint.integrations",
        icon: navIntegrations,
        badgeKey: "sidebar.comingSoon",
      },
    ],
  },
];

export const NAV_ACCOUNT: NavItem[] = [
  {
    id: "profile",
    page: "profile",
    labelKey: "sidebar.settings",
    hintKey: "sidebar.hint.profile",
    icon: navSettings,
  },
];

/** Labeled sidebar width from the 1440 frames. */
export const SIDEBAR_W = 240;

/** @deprecated The labeled panel folded into the sidebar. Kept so old imports compile. */
export const NAV_PANEL_W = SIDEBAR_W;
